import { Capacitor } from '@capacitor/core';

/** Native runtime detection; a mobile browser remains on the web implementation. */
export const isNativeApp = (): boolean => Capacitor.isNativePlatform();

/** Shared links must point to the public website, never capacitor://localhost. */
export function getPublicOrigin(): string {
  return isNativeApp() ? 'https://mattemonsteret.app' : window.location.origin;
}

/** Auth redirects return to the installed app through its registered scheme. */
export function getAuthRedirect(path = '/spill'): string {
  return isNativeApp()
    ? `mattemonsteret://auth/callback?next=${encodeURIComponent(path)}`
    : `${window.location.origin}${path}`;
}
